import axios from 'axios';

const buildUrl = (apiBaseURL, path) => `${apiBaseURL}${path}`;

export const validateCustomerRequest = (apiBaseURL, targetId) =>
    axios.get(buildUrl(apiBaseURL, `/api/Validation/validate-customer/${encodeURIComponent(targetId)}`));

export const getCustomerDetailsRequest = (apiBaseURL, targetId) =>
    axios.get(buildUrl(apiBaseURL, `/api/Validation/get-customer-details/${encodeURIComponent(targetId)}`));

export const getCustomerPaymentsRequest = (apiBaseURL, customerId) =>
    axios.get(buildUrl(apiBaseURL, `/api/Validation/customer-payments/${customerId}`));

export const getPaymentConfirmationRequest = (apiBaseURL, transactionId) =>
    axios.get(buildUrl(apiBaseURL, `/api/Validation/confirmation?transactionId=${transactionId}`));

export const createMercadoPagoPreferenceRequest = (apiBaseURL, payload) =>
    axios.post(buildUrl(apiBaseURL, '/api/Validation/mercadopago/create-preference'), payload);

const buildAuthConfig = (token) => ({
    headers: {
        Authorization: `Bearer ${token}`,
    },
});

export const loginRequest = (apiBaseURL, payload) =>
    axios.post(buildUrl(apiBaseURL, '/api/Auth/login'), payload);

export const getSpecialCustomersRequest = (apiBaseURL, search = '', token) =>
    axios.get(
        buildUrl(apiBaseURL, `/api/special-customers?search=${encodeURIComponent(search)}`),
        buildAuthConfig(token)
    );

export const saveSpecialCustomerRequest = (apiBaseURL, payload, token) =>
    axios.post(buildUrl(apiBaseURL, '/api/special-customers'), payload, buildAuthConfig(token));

export const importSpecialCustomersRequest = (apiBaseURL, customers, token) =>
    axios.post(
        buildUrl(apiBaseURL, '/api/special-customers/import'),
        { customers },
        buildAuthConfig(token)
    );

export const deleteSpecialCustomerRequest = (apiBaseURL, { customerCode, resal }, token) =>
    axios.delete(
        buildUrl(
            apiBaseURL,
            `/api/special-customers?customerCode=${encodeURIComponent(customerCode || '')}&resal=${encodeURIComponent(resal || '')}`
        ),
        buildAuthConfig(token)
    );
